import { signup, updateSite, uploadAvatar } from "../../transport/loginSignup";
import { isEmail } from "../../utils/validations";
import { initClickHandler } from "../../utils/initClickHandler";
import get from "../../lib/core/functional/get";
import curry from "../../lib/core/functional/curry";

export const signupAction = (event) => {
    const wrapper = event.currentTarget.parentNode.parentNode;
    const title = wrapper.querySelector(".comment--signup-name").value.trim();
    const email = wrapper.querySelector(".comment--signup-email").value.trim();
    const password = wrapper.querySelector(".comment--signup-password").value.trim();

    if (_validateSignup(wrapper, title, email, password)) {
        signup({ title, email, password })
            .then(_sucessSignupCallback(wrapper))
            .catch(_errorSignupCallback(wrapper));
    }
};

const _validateSignup = (wrapper, name, email, password) => {
    wrapper.querySelector(".comment--signup-name").classList.toggle("required", !name);
    wrapper.querySelector(".comment--signup-email").classList.toggle("required", !isEmail(email));
    wrapper.querySelector(".comment--signup-password").classList.toggle("required", !password);
    return !(!name || !email || !password);
};

const _sucessSignupCallback = (wrapper) => (resp) => {
    const site = {
        id: resp.site_id,
        name: resp.name,
        title: resp.site_title,
    };
    clearError(wrapper);
    wrapper.querySelector(".comment--signup-step1").classList.toggle("hidden", true);
    wrapper.querySelector(".comment--signup-step2").classList.toggle("hidden", false);
    initClickHandler(wrapper.querySelector(".comment--done-button"), signupDone(wrapper, site));
    const inputFile = wrapper.querySelector('input[type="file"]');
    inputFile.addEventListener("change", avatarUpload(wrapper));
};

const _errorSignupCallback = (wrapper) => (resp) => {
    var error = "Unknown Error";
    try {
        error = resp.join(",");
        /*eslint no-empty: "error"*/
    } catch (e) {
        // continue regardless of error
    } finally {
        showError(wrapper, error);
    }
};

const clearError = (wrapper) => showError(wrapper, false);

const showError = (wrapper, message) => {
    const errorBox = wrapper.querySelector(".comment--signup-step1 .comment--login--errors");
    if (message) {
        errorBox.classList.remove("hidden");
        errorBox.innerHTML = message;
    } else {
        errorBox.classList.add("hidden");
        errorBox.innerHTML = "";
    }
};

const avatarUpload = curry((wrapper, event) => {
    const inputField = event.currentTarget;
    if (!("files" in inputField) || inputField.files.length == 0) {
        return;
    }
    toggleLogoLoader(wrapper, false);
    const loaderElement = wrapper.querySelector(".community-site-logo .circle-loader");
    loaderElement.classList.remove("hidden");
    const formData = new FormData();
    formData.append("logo", inputField.files[0]);
    uploadAvatar(formData).then(_sucessUploadAvatar(wrapper)).catch(_errorUploadAvatar(wrapper));
});

const _sucessUploadAvatar = curry((wrapper, response) => {
    const logoElement = wrapper.querySelector(".community-site-logo .logo-preview");
    logoElement.style.backgroundImage = `url('${response.logo})`;
    logoElement.setAttribute("data-logo", response.logo);
    logoElement.setAttribute("data-image_id", response.image_id);
    toggleLogoLoader(wrapper, true);
});

const _errorUploadAvatar = curry((wrapper, error) => {
    toggleLogoLoader(wrapper, true);
    const errorText = get("error")(error);
    console.error(errorText ? errorText : error);
});

const toggleLogoLoader = (wrapper, force) => {
    const loader = wrapper.querySelector(".community-site-logo .circle-loader");
    loader.classList.toggle("hidden", force);
};

const signupDone = (wrapper, site) => () => {
    const logoElement = wrapper.querySelector(".community-site-logo .logo-preview");
    const logo = logoElement.getAttribute("data-logo");
    const imageId = logoElement.getAttribute("data-image_id");

    if (imageId) {
        const data = {
            ...site,
            storage: imageId,
            logo: logo,
        };
        updateSite(data).then(_successDone).catch(console.error);
    } else {
        _successDone();
    }
};

const _successDone = () => {
    document.location.reload(true);
};
